import { Theme } from "@mui/material/styles";
import { afiChameleonFinalTheme } from "../themes/afiChameleonFinalTheme";
import { hsLemonadeChameleonFinalTheme } from "../themes/hsLemonadeChameleonFinalTheme";

export enum CustomerGroup {
  HS_LEMONADE = "660",
}

export function resolveTheme(search: string): Theme {
  const params = new URLSearchParams(search.toLowerCase());
  const customerGroupId = params.get("customergroupid");

  if (customerGroupId === CustomerGroup.HS_LEMONADE) {
    return hsLemonadeChameleonFinalTheme;
  }

  return afiChameleonFinalTheme;
}
